import { SHADOWS } from '@ali/we-design-token';
import { BOX_SHADOWS } from '../consts/box-shadow';
export var CSS_BOX_SHADOWS = {
  XS: "box-shadow: " + BOX_SHADOWS.Shadow_XS + ";",
  S: "box-shadow: " + SHADOWS.S + ";",
  M: "box-shadow: " + BOX_SHADOWS.Shadow_M + ";",
  L: "box-shadow: " + SHADOWS.L + ";"
};
//# sourceMappingURL=box-shadow.js.map